<template>
  <div :class="['confirm-btn', { hide: !showCo }]">
    <div @click="del">Eyða leit</div>
    <div class="color-primary" @click="cancelConfirm">Hætta við</div>
  </div>
</template>

<script>
export default {
  props: ["del", "showCo", 'cancelConfirm'],
};
</script>
